import { Pagination } from "components";
import { config } from "constant";
import { FileCard, FilesLoading, NoFile } from "containers";
import { useAxios } from "hooks";
import { Fragment, useContext, useEffect, useState } from "react";
import { File, Paged } from "types";
import { PersonDetailsContext } from ".";

export default function Files() {
  const [axios, loading] = useAxios();
  const { user } = useContext(PersonDetailsContext);
  const [files, setFiles] = useState<Paged<File.Item> | null>(null);
  const [params, setParams] = useState<File.Params>({
    pageSize: config.pageSize,
    pageNumber: 1,
  });
  const hasFiles = !!files?.items.length || !!loading;
  const handleSetParams = (key: keyof File.Params) => {
    return (value: any) => {
      const isPageNumber = key === "pageNumber";
      setParams((p) => ({
        ...p,
        [key]: value,
        ...(!isPageNumber && { pageNumber: 1 }),
      }));
    };
  };
  const getFiles = () => {
    const url = `/People/${user.id}/get-all-userFiles`;
    const config = { params };
    const isFirstPage = config.params.pageNumber === 1;
    isFirstPage && setFiles(null);
    axios.get(url, config).then(({ data }) => {
      if (isFirstPage) return setFiles(data);
      setFiles((p) => ({ ...p!, items: [...p?.items!, ...data.items] }));
    });
  };

  useEffect(getFiles, [params, user.id]);
  return (
    <section className="px-5 space-y-2">
      <h2 className="text-base text-[#353740] font-medium pb-3">All files</h2>
      <hr />
      {!hasFiles && <NoFile />}
      {files?.items.map((e) => (
        <Fragment key={e.id}>
          <FileCard file={e} />
          <hr />
        </Fragment>
      ))}
      {loading ? (
        <FilesLoading />
      ) : (
        <Pagination
          activePage={params.pageNumber}
          setActivePage={handleSetParams("pageNumber")}
          totalPages={files?.totalPages}
        />
      )}
    </section>
  );
}
